import 'css-chunksrc/client/pages/projectPortfoliosPage/styles.scss';export default {
  "projectPortfoliosPage": "_projectPortfoliosPage_jwgti_1",
  "header": "_header_jwgti_8",
  "row": "_row_jwgti_17",
  "contextualMenuIcon": "_contextualMenuIcon_jwgti_25",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_jwgti_33",
  "title": "_title_jwgti_43",
  "profileNavigation": "_profileNavigation_jwgti_50",
  "toolbar": "_toolbar_jwgti_60",
  "button": "_button_jwgti_66",
  "icon": "_icon_jwgti_86",
  "iconBox": "_iconBox_jwgti_94",
  "main": "_main_jwgti_103",
  "wrapper": "_wrapper_jwgti_112",
  "projectPortfolios": "_projectPortfolios_jwgti_1",
  "exportButton": "_exportButton_jwgti_123"
};